import Cookies from '../../node_modules/js-cookie/dist/js.cookie.min';

const $ = jQuery;

var $cookieModal = $('#js-cookie-modal');
var $cookiesDetails = $('#js-cookies-details');
var $cookiesDetailsBtn = $('#js-cookies-settings');
var $cookieAgreementBtn = $('#js-cookie-agreement');
var $cookieSaveBtn = $('#js-cookie-modal-save');
var $cookiesModalDismissBtn = $('#js-cookie-modal-dismiss');
var $cookiesModalFeatureBtn = $('.js-feature-btn');
var $cookiesGoogle = $('#js-cookie-google');
var $cookiesMeta = $('#js-cookie-meta');
var $cookiesLinkedin = $('#js-cookie-linkedin');
var complianceCookie = {"Google Analytics":true,"Facebook":true,"LinkedIn":true};
var inconsonantAllCookie = {"Google Analytics":false,"Facebook":false,"LinkedIn":false};

if (!Cookies.get('AmplitivComplianceCookie')) {
  $cookieModal.removeClass('hidden');
} 

$cookiesDetailsBtn.on('click', function() {
  $cookieModal.addClass('hidden');
  $cookiesDetails.removeClass('hidden').addClass('visible');
});

$cookiesModalFeatureBtn.on('click', function(e) {
  e.preventDefault();
  $(this).toggleClass('primary-btn');
  $(this).siblings('button').toggleClass('primary-btn');
  if ($(this).parent().attr('data-consent') === 'true') {
    $(this).parent().attr('data-consent', 'false');
  } else {
    $(this).parent().attr('data-consent', 'true');
  }
});

//1 case: "OK, I agree";
$cookieAgreementBtn.on('click', function(e) {
  e.preventDefault();
  $.ajax({
    success: function(){
      Cookies.set('AmplitivComplianceCookie', JSON.stringify(complianceCookie), {
        expires: 365,
        domain: '.amplitiv.com',
        secure: true,
      });
    }
  });
  $cookieModal.addClass('hidden');
  $cookiesDetails.addClass('hidden');
});

//2 case: "I do not agree"
$cookiesModalDismissBtn.on('click', function() {
  $cookieModal.addClass('hidden');
  $cookiesDetails.addClass('hidden');
  complianceCookie = inconsonantAllCookie;
  $.ajax({
    success: function(){
      Cookies.set('AmplitivComplianceCookie', JSON.stringify(complianceCookie), {
        expires: 365,
        domain: '.amplitiv.com',
        secure: true,
      });
    }
  });
});

//3 case: "Save";
$cookieSaveBtn.on('click', function(e) {
  e.preventDefault();
  if ($cookiesGoogle.attr('data-consent') === 'false') {
    complianceCookie["Google Analytics"] = "false";
  }
  if($cookiesMeta.attr('data-consent') === 'false'){
    complianceCookie["Facebook"] = "false";
  }
  if($cookiesLinkedin.attr('data-consent') === 'false'){
    complianceCookie["LinkedIn"] = "false";
  }
  $.ajax({
    success: function(){
      Cookies.set('AmplitivComplianceCookie', JSON.stringify(complianceCookie), {
        expires: 365,
        domain: '.amplitiv.com',
        secure: true,
      });
    }
  });
  $cookieModal.addClass('hidden');
  $cookiesDetails.addClass('hidden');
});
